import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { ApplicableTableSettings, mblStatus } from '../../../../tableSettings';

import IfmsDate from '../../../../ui/Date';
import TextBox from '../../../../ui/TextBox';
import CheckBox from '../../../../ui/CheckBox';
import { Time } from '../../../../ui/DateTime';
import SmartTable from '../../../../uiControls/SmartTable';
import OceanUnPortLookupField from '../../../../uiControls/lookup/OceanUnPortLookupField';

import { DefaultContainerMilestoneStatus } from './implementationConstants';
import { now, getTime, formatDateTime, formatDate } from '../../../../dateUtils';
import { PimsCntrEvent } from '../../../../fms.core/PimsCntrEvent';
import { GenMain } from '../../../../fms.core/GenMain';

function SelectRenderer({data, row}:any) {
  if (//[save-sqlinfo]!row.original.editable
    !row.original.selectable) {
    return <div className="ifms-table-default"><CheckBox value={false} disabled dark={true} /></div>;
  }

  const toggleRow = data[0].toggleRow;
  const selectedIndeces = data[0].selectedIndeces;

  const selected = selectedIndeces.findIndex((x:any) => x === row.index) >= 0 || !!data[row.index].date;
  
  return <div className="ifms-table-default"><CheckBox name={`${row.original.name}-check-${row.index}`} value={row.original.selectable && selected} disabled={!row.original.selectable} onChange={(select) => toggleRow(row.index, select)} /></div>;
}

function StatusNameRenderer({ cell }:any) {
  return <div style={{textAlign: 'left', marginLeft: '5px', paddingTop: '2px', fontSize: '11px'}}>{cell.value}</div>;
}

function DateRenderer({data, row}:any) {
  if (//[save-sqlinfo]!row.original.editable
    !row.original.selectable) {
    return <div style={{marginTop: '0px'}}><IfmsDate disabled value={row.original.date} /></div>;
  }

  const onRowChange = data[0].onRowChange;
  const selectedIndeces = data[0].selectedIndeces;

  let selected = selectedIndeces.findIndex((x:any) => x === row.index) >= 0 || !!data[row.index].date;

  function onChange(date: string|null) {
    if (!date) {
      onRowChange(row.index, {
        date: null,
        time: null,
        datetime: null,
      }, selected);
    } else {
      const tIndex = date.indexOf('T');
      const datetime = tIndex >= 0 ? `${date.substring(0, tIndex)}T${row.original.time}` : row.original.datetime;

      onRowChange(row.index, {
        date: date,
        datetime,
      }, selected);
    }
  }

  return <div style={{marginTop: '0px'}}><IfmsDate name={`${row.original.name}-date-${row.index}`} disabled={!selected} value={row.original.date} onChange={onChange} /></div>;
}

function TimeRenderer({data, row}:any) {
  if (//[save-sqlinfo]!row.original.editable
    !row.original.selectable) {
    return <div style={{marginTop: '0px'}}><TextBox disabled placeholder={'HH:MM'} value={row.original.time || ''} /></div>;
  }

  const onRowChange = data[0].onRowChange;
  const selectedIndeces = data[0].selectedIndeces;

  const selected = selectedIndeces.findIndex((x:any) => x === row.index) >= 0 || !!data[row.index].date;

  function onChange(changedTime: string|null) {
    if (!row.original.date) {
      return;
    }

    const timeToApply = changedTime ?? '00:00';

    const tIndex = row.original.date.indexOf('T');
    const datetime = tIndex >= 0 ? `${row.original.date.substring(0, tIndex)}T${timeToApply}` : row.original.datetime;


    onRowChange(row.index, {
      time: timeToApply,
      datetime,
    }, selected);
  }

  return <div style={{marginTop: '0px'}}><Time name={`${row.original.name}-time-${row.index}`} disabled={!selected} value={row.original.time} onChange={onChange} /></div>;
}

function LocationRenderer({data, row}:any) {
  if (//[save-sqlinfo]!row.original.editable
    !row.original.selectable) {
    return <span></span>;
  }

  const onRowChange = data[0].onRowChange;
  const selectedIndeces = data[0].selectedIndeces;

  const selected = selectedIndeces.findIndex((x:any) => x === row.index) >= 0 || !!data[row.index].date;

  return selected
    ? <div style={{marginTop: '0px', width: '100%'}}>
        <OceanUnPortLookupField
          name={`${row.original.name}-locName-${row.index}`}
          lookupId='contaienrStatus-locName'
          //<save-sqlinfo:
          // initialValue={row.original.location ? row.original.location.unCodeWithPortName : ''}
          // onTextChange={unCodeWithPortName => onRowChange(row.index, { location: { ...row.original.location, unCodeWithPortName }})}
          // onSelect={location => onRowChange(row.index, {location})}
          initialValue={row.original.locName ?? ''}
          onTextChange={locName => onRowChange(row.index, { locName }, selected)}
          onSelect={location => onRowChange(row.index, { locName: location.portName }, selected)}
          //save-sqlinfo>
          //searchBy ="unWithPortName"
          searchBy="portName"
        />
    </div>
    : <div className="ifms-table-align-left">
      {/* [save-sqlinfo]{row.original.location ? row.original.location.unCodeWithPortName : ''} */}
      {row.original.locName ?? ''}
    </div>;
}

function LastEventTimeRenderer({row, data}:any) {
  //<save-sqlinfo:
  // const defaultStatus = data[0].defaultStatus;
  // const defaultStatusTimestamp = defaultStatus ? defaultStatus.find((x:any) => x.statusName === row.original.statusName).lastEventDateTime : '';

  // const timestamp = row.original.selectable ? row.original.lastEventDateTime : defaultStatusTimestamp;
  //save-sqlinfo>
  return (
    <TextBox //[save-sqlinfo]value={formatDateTime(timestamp)} 
      name={`${row.original.name}-lastDate-${row.index}`}
      value={formatDateTime(row.original.lastDate)}
    disabled />
  );
}

function MblMilestoneContainerStatus({
  //[save-sqlinfo]defaultStatus,
  selectedIndex,
  status,
  applyToAll,
  onChange,
  isView,
  mbl,
}:{
  selectedIndex: number,    // selected container index
  status: Array<PimsCntrEvent>|null, 
  onChange: (rowIndex: number, status: Array<PimsCntrEvent>, select: boolean) => void,   
  applyToAll: (status: Array<PimsCntrEvent>) => void,    
  isView: boolean,
  mbl:GenMain
}) {
  // const selectable = !!status;

  const [selectedIndeces, setSelectedIndeces] = useState<Array<any>>([]);

  useEffect(() => {
    setSelectedIndeces([]);
  }, [selectedIndex]);

  /**
   * pt211230 - add comment
   * if rowIndex resides in selectedIndices state, then remove it, 
   * otherwise add rowIndex into selectedIndices and update row data
   * @param rowIndex 
   */
  function toggleRow(rowIndex: any, select: boolean) {
    const index = selectedIndeces.findIndex(x => x === rowIndex);
    if (index >= 0) {
      const indeces = [...selectedIndeces];
      indeces.splice(index, 1);
      setSelectedIndeces(indeces);
      onRowChange(rowIndex, {
        date: null,
        time: null,
        datetime: null,
        locName: '',
      }, select);
    } else {
      setSelectedIndeces([...selectedIndeces, rowIndex]);

      var currentTime = now();
      let tempLocName = '';
      const time = getTime(currentTime);

      switch (rowIndex) {
        case 0: case 1: case 2: case 3: case 4:
          tempLocName = mbl.loadingPort;
          break;
          case 7: case 8: case 9: case 10: 
          tempLocName = mbl.discharge;
          break;
          case 5: case 6: case 11: case 12: case 13: case 14: case 15:
          tempLocName = mbl.finalDest;
          break;
        default:
          tempLocName = '';
          break;
      }

      onRowChange(rowIndex, {
        date: formatDate(currentTime),  //currentTime,
        time,
        //dateTime: formatDateTime(currentTime),
        datetime: currentTime,
        locName: tempLocName
      }, select);
    }
  }

  /**
   * pt211230 - add comment
   * Apply change to mbl.milestone.eventListItems[rowIndex]
   * @param rowIndex index of PimsCntrEvent[]
   * @param change {Partial<PimsCntrEvent>}
   */
  function onRowChange(rowIndex: number, change: any, select: boolean) {
    if (!status) {
      return;
    }

    //<save-sqlinfo: status[rowIndex] is not updated
    // const s = [...status];
    // s[rowIndex] = {
    //   ...s[rowIndex],
    //   ...change,
    // };
    Object.assign(status[rowIndex], change);
    //save-sqlinfo>

    onChange(selectedIndex, [status[rowIndex]], select);   // Update corresponding OmContainer
  }


  const statusData = !!status ? status : DefaultContainerMilestoneStatus;

  const tableOptions:ApplicableTableSettings = {
    tableName: 'mblStatus',
    ...mblStatus,
    data: statusData.map((x:any, i:number) => ({...x, i, onRowChange, toggleRow, 
      // selectable: [
      //   OceanMblStatusMap.get(OceanEventName.CarrierRelease)?.label, 
      //   OceanMblStatusMap.get(OceanEventName.CustomsRelease)?.label, 
      //   OceanMblStatusMap.get(OceanEventName.DevanInstToCfs)?.label, 
      //   OceanMblStatusMap.get(OceanEventName.ReturnEmptyContainer)?.label
      // ].indexOf(x.name) < 0,
      //name: x.statusName,
      selectable: true,
      selectedIndeces, //[save-sqlinfo]defaultStatus 
    })),
    rowRenderers: [
      //<save-sqlinfo
      // { accessor: 'select', Cell: SelectRenderer },
      // { accessor: 'statusName', Cell: StatusNameRenderer },
      // { accessor: 'date', Cell: DateRenderer },
      // { accessor: 'time', Cell: TimeRenderer },
      // { accessor: 'location', Cell: LocationRenderer },
      // { accessor: 'lastEventTime', Cell: LastEventTimeRenderer }
      { accessor: 'check', Cell: SelectRenderer },
      { accessor: 'name', Cell: StatusNameRenderer },
      { accessor: 'date', Cell: DateRenderer },
      { accessor: 'time', Cell: TimeRenderer },
      { accessor: 'locName', Cell: LocationRenderer },
      { accessor: 'lastDate', Cell: LastEventTimeRenderer }
      //save-sqlinfo>
    ],
  };

  return (
    <div>
      <SmartTable {...tableOptions} />
    </div>
  );
}

MblMilestoneContainerStatus.propTypes = {
  selectedIndex: PropTypes.number,
  status: PropTypes.array,
  applyToAll: PropTypes.func,
  onChange: PropTypes.func,
  tableStorage: PropTypes.object,
  defaultStatus: PropTypes.any,
};

export default React.memo(MblMilestoneContainerStatus);
